import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { WalletTransaction } from "../../Schemas/Wallet";

interface Filter extends IFilterSchema {
  column: WalletTransactionListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: WalletTransactionListColumnSortable;
}

// 'required|in:id,wallet_id,payment_receipt_id,debit,credit,description,created_at',
export enum WalletTransactionListColumnFilterable {
  DEBIT = "debit",
  CREDIT = "credit",
  DESCRIPTION = "description",
  CREATED_AT = "created_at",
  WALLET_ID = "wallet_id",
  PAYMENT_RECEIPT_ID = "payment_receipt_id",
  VOICE_BROADCAST_ID = "voice_broadcast_id"
}
export enum WalletTransactionListColumnSortable {
  DEBIT = "debit",
  CREDIT = "credit",
  DESCRIPTION = "description",
  CREATED_AT = "created_at",
  ID="id"
}

interface WalletTransactionListUrlParams {
  workspaceId: number;
}

interface WalletTransactionListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface WalletTransactionListResponseBody extends IResponseBody {
  data: {
    wallet_transactions: WalletTransaction[];
    total: number;
  };
}

export class WalletTransactionListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/wallet-transactions`;
  }

  async send(
    queryStrings?: WalletTransactionListQueryString
  ): Promise<WalletTransactionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
